function Pillars(props) {
	return props.pillars;
}

export default Pillars;